/**
 * @file src/helpers/ory/utils/validations.ts
 * @exports emailValidation, passwordValidation
 * @summary Yup validation schemas for authentication forms. Email validation provides specific, actionable suggestions for common formatting errors (WCAG 2.1 AA SC 3.3.3).
 */

import * as yup from "yup";

import { getEmailSuggestion } from "./getEmailSuggestion";

const REGEX_NO_SPACE = /^[^\s]*$/;

// Yup's own email regex — used as a permissive fallback so we don't
// reject any emails that the previous .email() call would have accepted.
const YUP_EMAIL_REGEX =
	/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export const emailValidation = yup
	.string()
	.required("Email is required.")
	.test("email-format-suggestions", "Invalid email", function (value) {
		if (!value) return true; // let required rule handle this case

		// Specific, actionable suggestions for common issues
		const suggestion = getEmailSuggestion(value);
		if (suggestion) {
			return this.createError({ message: suggestion });
		}

		// Fallback: general format check (same permissiveness as Yup's .email())
		if (!YUP_EMAIL_REGEX.test(value)) {
			return this.createError({ message: "Please enter a valid email address." });
		}

		return true;
	});

export const passwordValidation = yup
	.string()
	.required(`Password is required.`)
	.min(8, "Minimum of 8 characters.")
	.matches(REGEX_NO_SPACE, "Please remove spaces");
